import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalDataService } from '@core/services';


@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent implements OnInit {




  constructor(
    public router: Router,
    private _GlobalDataService: GlobalDataService,
  ) { }

  ngOnInit(): void {
    if (this.router.url.includes('(loginview:')) {
      return;
    }

    // this.router.navigate(["/standalone/home", { outlets: { 'navview': ['suivi-campagnes', this._GlobalDataService.Annonceur.IdAnnonceur] } }], {

    this.router.navigate(["/administration/loginpage", { outlets: { 'loginview': ['login'] } }], {
      queryParams: this._GlobalDataService.objectParams, queryParamsHandling: "merge",
      skipLocationChange: true
    }).then((e) => {
      if (e) {
        console.log("Navigation is successful!");
      } else {
        console.log("Navigation has failed!");
      }
    });
  }





}
